import { render, staticRenderFns } from "./dialogSystemPolicy.vue?vue&type=template&id=75fbbaec&scoped=true&lang=pug&"
import script from "./dialogSystemPolicy.vue?vue&type=script&lang=js&"
export * from "./dialogSystemPolicy.vue?vue&type=script&lang=js&"
import style0 from "./dialog.scss?vue&type=style&index=0&id=75fbbaec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fbbaec",
  null
  
)

export default component.exports